import OktaAuth from '@okta/okta-auth-js';
import { environment } from 'src/environments/environment';

export function oktaSettings() {
    const oktaAuth = new OktaAuth(environment.auth);
    return {
      oktaAuth
    };
}
